class DLPageAddToCartX extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // 右侧产品图相关元素
    this.imageContainer = this.querySelector('.dl-page-addtocart-x-product-image-container');
    this.images = this.imageContainer?.querySelectorAll('img');
    this.colors = this.querySelectorAll('.dl-product-grid-item-h-colors-item');
    this.form = this.querySelector('form[action^="/cart/add"]');
    this.formIdInput = this.form?.querySelector('[name="id"]');
    this.formButton = this.form?.querySelector('[type="submit"]');
    this.priceContainer = this.querySelector('.dl-page-addtocart-x-current-price');
    this.originalPriceContainer = this.querySelector('.dl-page-addtocart-x-original-price');
    this.preTag = this.querySelector('.dl-product-grid-item-h-preorder');
    this.infoMain = this.querySelector('.dl-page-addtocart-x-product-info');
    this.preorderInfo = this.querySelector('.dl-page-addtocart-x-shipping-info');
    this.productForm = this.form;
    this.installments = this.querySelector('dl-product-installments-h');

    // 左侧主图相关元素
    this.mainImageContainer = this.querySelector('.dl-page-addtocart-x-image');
    this.mainImageItems = this.mainImageContainer?.querySelectorAll('.dl-page-addtocart-x-image-item');

    // 标签相关元素
    this.tabs = this.querySelectorAll('.dl-page-addtocart-x-product-tabs-items');
    this.leftArrow = this.querySelector('.dl-page-addtocart-x-nav-arrow-left');
    this.rightArrow = this.querySelector('.dl-page-addtocart-x-nav-arrow-right');
    this.currentTabIndex = 0;
    this.productSelect = this.querySelector('.dl-page-addtocart-x-product-select-container select');

    this.couponCopyBtn = this.querySelector('.dl-page-addtocart-x-coupon-copy-btn');

    // 初始化
    this.bindEvents();
    this.updateArrowStates();
    this.initializeImages();
    const selectedMainImageItem = this.querySelector('.dl-page-addtocart-x-image-item.dl-selected');
    if (selectedMainImageItem) {
      this.updateProductInfo(selectedMainImageItem);
      this.updatePriceDisplay({ mainImageItem: selectedMainImageItem });
    }
  }

  getVariantId(el) {
    if (!el) return '';
    return el.getAttribute('data-dl-variant-id')
      || el.getAttribute('data-variant-id')
      || el.dataset?.dlVariantId
      || el.dataset?.variantId
      || '';
  }

  toCents(value) {
    const amount = Number(value);
    if (Number.isNaN(amount)) return value;
    return String(Math.round(amount));
  }

  // 初始化图片显示
  initializeImages() {
    if (!this.mainImageItems || this.mainImageItems.length === 0) return;

    // 获取默认选中的变体ID
    let defaultVariantId = null;

    // 优先从表单中获取默认变体ID
    if (this.formIdInput) {
      defaultVariantId = this.formIdInput.value;
    }

    // 如果表单中没有，尝试从颜色选择器获取
    if (!defaultVariantId && this.colors?.length > 0) {
      const defaultColor = Array.from(this.colors).find(color => color.classList.contains('dl-selected'));
      defaultVariantId = this.getVariantId(defaultColor || this.colors[0]);
    }

    // 如果还是没有，从右侧产品图获取
    if (!defaultVariantId) {
      const defaultImage = this.imageContainer?.querySelector('img.dl-selected') || this.images?.[0];
      defaultVariantId = this.getVariantId(defaultImage);
    }

    // 更新主图显示
    this.mainImageItems.forEach(item => item.classList.remove('dl-selected'));
    const matchingImage = defaultVariantId
      ? Array.from(this.mainImageItems).find(item => this.getVariantId(item) === String(defaultVariantId))
      : null;
    (matchingImage || this.mainImageItems[0])?.classList.add('dl-selected');

    // 初始化分期信息
    if (this.installments) {
      // 获取当前选中图片的价格
      const selectedImage = this.imageContainer?.querySelector('img.dl-selected');
      const selectedColor = Array.from(this.colors).find(color => color.classList.contains('dl-selected'));
      const variant_price = selectedImage?.dataset.variantPrice || selectedColor?.dataset.dlVariantPrice;
      const variant_sku = selectedImage?.dataset.variantSku || selectedColor?.dataset.dlVariantSku;
      
      if (variant_price) {
        this.installments.changeAmount(variant_price, variant_sku);
      }
    }
  }

  // 更新左侧主图显示
  updateMainImage(variantId) {
    if (!this.mainImageItems || !variantId) return;

    // 找到当前选中的图片
    const currentSelected = Array.from(this.mainImageItems).find(item =>
      item.classList.contains('dl-selected')
    );

    const matchingImageItem = Array.from(this.mainImageItems).find(item => {
      return this.getVariantId(item) === String(variantId);
    });

    if (matchingImageItem) {
      if (currentSelected !== matchingImageItem) {
        this.mainImageItems.forEach(item => item.classList.remove('dl-selected'));
        matchingImageItem.classList.add('dl-selected');
      }
      this.updateProductInfo(matchingImageItem);
    }
  }

  // 更新产品标题和描述
  updateProductInfo(matchingImageItem) {
    if (!matchingImageItem || !this.infoMain) return;
    const productTitle = matchingImageItem.dataset.productTitle;
    const productTitleM = matchingImageItem.dataset.productTitleM;
    const productDescription = matchingImageItem.dataset.productDescription;
    const productDescriptionM = matchingImageItem.dataset.productDescriptionM;
    const discountCode = matchingImageItem.dataset.discountCode;
    const discountText = matchingImageItem.dataset.discountText;
    const productTags = matchingImageItem.dataset.productTags;
    const learnMoreUrl = matchingImageItem.dataset.learnMoreUrl;
    const titlePc = this.infoMain.querySelector('.dl-page-addtocart-x-product-title.dl-hidden-mobile');
    const titleM = this.infoMain.querySelector('.dl-page-addtocart-x-product-title.dl-hidden-desktop');
    const descPc = this.infoMain.querySelector('.dl-page-addtocart-x-product-description.dl-hidden-mobile');
    const descM = this.infoMain.querySelector('.dl-page-addtocart-x-product-description.dl-hidden-desktop');
    if (productTitle && titlePc) titlePc.textContent = productTitle;
    if (productTitleM && titleM) titleM.textContent = productTitleM;
    if (productDescription && descPc) descPc.textContent = productDescription;
    if (productDescriptionM && descM) descM.textContent = productDescriptionM;
    this.updateCoupon(discountCode, discountText);
    if (this.infoMain.querySelector('.dl-page-addtocart-x-product-tags')) {
      if (productTags) {
        const productTagsArray = productTags.split(',');
        const productTagsHtml = productTagsArray.map(tag => `<span class="dl-page-addtocart-x-product-tag">${tag}</span>`).join('');
        this.infoMain.querySelector('.dl-page-addtocart-x-product-tags').innerHTML = productTagsHtml;
      } else {
        this.infoMain.querySelector('.dl-page-addtocart-x-product-tags').innerHTML = '';
      }
    }
    if (learnMoreUrl) {
      const learnMoreBtn = this.querySelector('.dl-page-addtocart-x-learn-more-btn');
      if (learnMoreBtn) {
        learnMoreBtn.href = learnMoreUrl;
      }
    }
  }

  updateCoupon(discountCode, discountText) {
    if (!this.infoMain) return;
    const couponContainer = this.infoMain.querySelector('.dl-page-addtocart-x-coupon-container');
    const couponItemCode = this.infoMain.querySelector('.dl-page-addtocart-x-coupon-item-code');
    const couponCopyBtn = this.infoMain.querySelector('.dl-page-addtocart-x-coupon-copy-btn');
    if (!couponContainer || !couponItemCode || !couponCopyBtn) return;

    const normalizedCode = (discountCode || '').trim();
    const normalizedText = (discountText || '').trim();
    if (normalizedCode) {
      couponContainer.style.display = '';
      couponItemCode.textContent = normalizedText || normalizedCode;
      couponCopyBtn.dataset.discountCode = normalizedCode;
      couponCopyBtn.classList.remove('dl-copied');
    } else {
      couponContainer.style.display = 'none';
      couponItemCode.textContent = '';
      couponCopyBtn.dataset.discountCode = '';
      couponCopyBtn.classList.remove('dl-copied');
    }
  }

  getCurrentTabKey() {
    if (!this.tabs || this.tabs.length === 0) return '';
    const tabValue = this.tabs[this.currentTabIndex]?.dataset.tabValue;
    if (!tabValue) return '';
    return tabValue.toLowerCase().trim().replace(/\s+/g, '-');
  }

  updatePriceDisplay({ colorOption, targetImage, mainImageItem } = {}) {
    if (!this.priceContainer) return;

    let finalFormatted = '';
    let originalFormatted = '';
    let showCompare = false;
    let finalCents = null;

    const tabKey = this.getCurrentTabKey();

    // 左侧 block 数据包含页面专属折扣，优先级高于右侧元对象价格数据。
    if (mainImageItem?.dataset.finalPriceFormatted) {
      finalFormatted = mainImageItem.dataset.finalPriceFormatted;
      originalFormatted = mainImageItem.dataset.originalPriceFormatted || '';
      showCompare = mainImageItem.dataset.showCompare === 'true';
      finalCents = mainImageItem.dataset.finalPrice;
    }

    // 兼容旧版 X 卡片只输出 cents 数值的价格属性。
    if (!finalFormatted && mainImageItem?.dataset.finalPrice) {
      finalCents = this.toCents(mainImageItem.dataset.finalPrice);
      const originalCents = this.toCents(mainImageItem.dataset.originalPrice);
      finalFormatted = typeof formatMoney === 'function' ? formatMoney(finalCents) : finalCents;
      if (originalCents && Number(originalCents) > Number(finalCents)) {
        originalFormatted = typeof formatMoney === 'function' ? formatMoney(originalCents) : originalCents;
        showCompare = true;
      }
    }

    if (!finalFormatted && colorOption) {
      if (tabKey) {
        finalFormatted = colorOption.getAttribute(`data-variant-final-price-formatted-${tabKey}`) || '';
        originalFormatted = colorOption.getAttribute(`data-variant-original-price-formatted-${tabKey}`) || '';
        showCompare = colorOption.getAttribute(`data-variant-show-compare-${tabKey}`) === 'true';
        finalCents = colorOption.getAttribute(`data-variant-final-price-${tabKey}`);
      }
      if (!finalFormatted) {
        finalFormatted = colorOption.dataset.dlVariantFinalPriceFormatted
          || colorOption.dataset.variantFinalPriceFormatted
          || '';
        originalFormatted = colorOption.dataset.dlVariantOriginalPriceFormatted
          || colorOption.dataset.variantOriginalPriceFormatted
          || '';
        showCompare = colorOption.dataset.dlVariantShowCompare === 'true'
          || colorOption.dataset.variantShowCompare === 'true';
        finalCents = colorOption.dataset.variantFinalPrice || colorOption.dataset.dlVariantFinalPrice;
      }
    }

    if (!finalFormatted && targetImage?.dataset.variantFinalPriceFormatted) {
      finalFormatted = targetImage.dataset.variantFinalPriceFormatted;
      originalFormatted = targetImage.dataset.variantOriginalPriceFormatted || '';
      showCompare = targetImage.dataset.variantShowCompare === 'true';
      finalCents = targetImage.dataset.variantFinalPrice;
    }

    if (!finalFormatted) {
      const rawVariantPrice = targetImage?.dataset.variantPrice
        || (tabKey && colorOption?.getAttribute(`data-variant-price-${tabKey}`))
        || colorOption?.dataset.dlVariantPrice;
      if (rawVariantPrice) {
        finalCents = this.toCents(rawVariantPrice);
        finalFormatted = typeof formatMoney === 'function' ? formatMoney(finalCents) : finalCents;
      }
    }

    if (finalFormatted) {
      this.priceContainer.textContent = finalFormatted;
    }

    if (this.originalPriceContainer) {
      if (showCompare && originalFormatted) {
        this.originalPriceContainer.textContent = originalFormatted;
        this.originalPriceContainer.style.display = '';
      } else {
        this.originalPriceContainer.style.display = 'none';
      }
    }

    if (this.installments && finalCents) {
      const variantSku = mainImageItem?.dataset.variantSku
        || targetImage?.dataset.variantSku
        || colorOption?.dataset.dlVariantSku;
      this.installments.changeAmount(finalCents, variantSku);
    }
  }

  // 绑定事件
  bindEvents() {
    // 颜色选择器点击事件
    this.colors.forEach(color => {
      color.addEventListener('click', this.handleColorClick.bind(this));
    });

    // 标签箭头点击事件
    this.leftArrow?.addEventListener('click', () => this.switchTab('left'));
    this.rightArrow?.addEventListener('click', () => this.switchTab('right'));

    this.couponCopyBtn?.addEventListener('click', this.handleCouponCopyClick.bind(this));
    // 标签点击事件
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => this.handleTabClick(e, index));
    });
    this.productSelect?.addEventListener('change', this.handleProductSelectChange.bind(this));
  }

  handleCouponCopyClick(e) {
    e.preventDefault();
    const discountCode = e.currentTarget.dataset.discountCode;
    if (discountCode) {
      copyTextToClipboard(discountCode);
      this.couponCopyBtn.classList.add('dl-copied');
    }
  }
  
  handleProductSelectChange(e) {
    e.preventDefault();
    const productSelect = e.currentTarget;
    const selectedValue = productSelect.value;
    const targetTabIndex = Array.from(this.tabs).findIndex(tab => {
      return tab.dataset.tabValue === selectedValue;
    });
    if (targetTabIndex !== -1) {
      this.handleTabClick(e, targetTabIndex);
    }
  }

  // 处理颜色点击
  handleColorClick(e) {
    e.preventDefault();
    const color_option = e.currentTarget;
    const variant_id_from_color = color_option.dataset.dlVariantId;
    const color_value = color_option.dataset.colorValue;

    // 获取当前选中的标签值
    let tab_value = '';
    if (this.tabs.length > 0) {
      const currentTab = this.tabs[this.currentTabIndex];
      tab_value = currentTab.dataset.tabValue;
    }

    // 查找匹配的图片
    let variant_image = null;
    if (this.tabs.length > 0 && tab_value) {
      // 使用双绑定逻辑：根据颜色值和标签值查找图片
      variant_image = Array.from(this.images || []).find(img => {
        return img.dataset.colorValue === color_value && img.dataset.tabValue === tab_value;
      });
    } else {
      // 如果没有标签，使用原有的variant_id查找逻辑
      variant_image = this.imageContainer.querySelector(`img[data-dl-variant-id="${variant_id_from_color}"]`) ||
        this.imageContainer.querySelector(`img[data-variant-id="${variant_id_from_color}"]`);
    }

    // 更新右侧产品图显示状态
    (this.images || []).forEach(image => image.classList.remove('dl-selected'));
    variant_image?.classList.add('dl-selected');

    // 更新颜色选择器状态
    this.colors.forEach(color => color.classList.remove('dl-selected'));
    color_option.classList.add('dl-selected');

    // 获取最终的变体ID
    let variant_id_from_image = variant_image?.dataset.variantId || variant_image?.dataset.dlVariantId;
    if (this.tabs.length > 0 && tab_value) {
      const tabKeyForId = tab_value.toLowerCase().replace(/\s+/g, '-');
      const idAttr = color_option.getAttribute(`data-dl-variant-id-${tabKeyForId}`);
      if (idAttr) {
        variant_id_from_image = idAttr;
      }
    }
    const actual_variant_id = variant_id_from_image || variant_id_from_color;

    // 更新左侧主图
    this.updateMainImage(actual_variant_id);

    // 更新表单变体ID
    if (this.formIdInput && actual_variant_id) {
      this.formIdInput.value = actual_variant_id;
      this.updateUrl(actual_variant_id);
    }

    // 更新按钮状态
    const available = variant_image?.dataset.variantAvailable ?? color_option.dataset.dlVariantAvailable;
    if (this.formButton) {
      this.formButton.disabled = (available !== 'true');
    }
    // 更新价格显示
    const selectedMainImageItem = Array.from(this.mainImageItems || []).find(item => {
      return this.getVariantId(item) === String(actual_variant_id);
    });
    this.updatePriceDisplay({
      colorOption: color_option,
      targetImage: variant_image,
      mainImageItem: selectedMainImageItem
    });

    // 更新预售信息
    this.updatePreorderInfo(actual_variant_id);
  }

  updateUrl(actual_variant_id) {
    let product_handle = this.dataset.dlProductHandle;

    let image_container = this.querySelector('.dl-page-addtocart-x-product-image-container');
    let title_containers = this.querySelectorAll('.dl-page-addtocart-x-product-title');

    image_container.href = `/products/${product_handle}?variant=${actual_variant_id}`;
    title_containers.forEach(title => {
      title.href = `/products/${product_handle}?variant=${actual_variant_id}`;
    });
  }

  // 处理标签点击
  handleTabClick(e, index) {
    if (index === this.currentTabIndex) return;

    // 获取当前选中的颜色值
    const selectedColor = this.querySelector('.dl-product-grid-item-h-colors-item.dl-selected');
    const color_value = selectedColor ? selectedColor.dataset.colorValue : '';
    const tab_value = this.tabs[index].dataset.tabValue;

    // 查找匹配的图片
    let targetImage = null;
    if (color_value && tab_value) {
      targetImage = Array.from(this.images || []).find(img => {
        return img.dataset.colorValue === color_value && img.dataset.tabValue === tab_value;
      });
    }

    // 仅有标签选项时，根据标签值匹配图片
    if (!targetImage && tab_value) {
      targetImage = Array.from(this.images || []).find(img => img.dataset.tabValue === tab_value);
    }

    if (targetImage) {
      // 更新右侧产品图
      (this.images || []).forEach(image => image.classList.remove('dl-selected'));
      targetImage.classList.add('dl-selected');

      // 获取变体ID并更新左侧主图
      const variantId = targetImage.dataset.variantId || targetImage.dataset.dlVariantId;
      this.updateMainImage(variantId);

      // 更新表单和其他显示状态
      this.updateFormAndDisplay(targetImage, variantId);
    }

    // 更新标签状态
    this.updateTabState(index);
  }

  // 切换标签
  switchTab(direction) {
    if (!this.tabs || this.tabs.length === 0) return;

    let newIndex = this.currentTabIndex;
    if (direction === 'left') {
      newIndex = Math.max(0, this.currentTabIndex - 1);
    } else if (direction === 'right') {
      newIndex = Math.min(this.tabs.length - 1, this.currentTabIndex + 1);
    }

    if (newIndex !== this.currentTabIndex) {
      this.handleTabClick(null, newIndex);
    }
  }

  // 更新标签状态
  updateTabState(newIndex) {
    this.tabs.forEach(tab => {
      tab.classList.remove('dl-page-addtocart-x-product-tabs-item-selected');
    });

    this.currentTabIndex = newIndex;
    this.tabs[this.currentTabIndex]?.classList.add('dl-page-addtocart-x-product-tabs-item-selected');
    this.updateArrowStates();
  }

  // 更新箭头状态
  updateArrowStates() {
    if (!this.tabs || this.tabs.length === 0) {
      this.leftArrow?.style.setProperty('pointer-events', 'none');
      this.rightArrow?.style.setProperty('pointer-events', 'none');
      return;
    }

    // 更新左箭头状态
    if (this.leftArrow) {
      const isFirst = this.currentTabIndex === 0;
      this.leftArrow.classList.toggle('dl-disabled', isFirst);
      this.leftArrow.style.setProperty('pointer-events', isFirst ? 'none' : 'auto');
    }

    // 更新右箭头状态
    if (this.rightArrow) {
      const isLast = this.currentTabIndex === this.tabs.length - 1;
      this.rightArrow.classList.toggle('dl-disabled', isLast);
      this.rightArrow.style.setProperty('pointer-events', isLast ? 'none' : 'auto');
    }
  }

  // 更新表单和显示状态
  updateFormAndDisplay(targetImage, variantId) {
    // 更新表单变体ID
    if (this.formIdInput && variantId) {
      this.formIdInput.value = variantId;
      this.updateUrl(variantId);
    }
    // 找到匹配的新图片
    const matchingImageItem = Array.from(this.mainImageItems || []).find(item => {
      return this.getVariantId(item) === String(variantId);
    });
    const selectedColor = this.querySelector('.dl-product-grid-item-h-colors-item.dl-selected');
    this.updatePriceDisplay({
      colorOption: selectedColor,
      targetImage,
      mainImageItem: matchingImageItem
    });

    // 更新按钮状态
    const variantAvailable = targetImage.dataset.variantAvailable;
    if (this.formButton) {
      this.formButton.disabled = (variantAvailable !== 'true');
    }

    // 更新预售信息
    this.updatePreorderInfo(variantId);
  }

  // 更新预售信息
  updatePreorderInfo(variantId) {
    if (typeof dl_product_preorder !== 'undefined' && dl_product_preorder[variantId]) {
      this.preTag?.classList.add('dl-show');
      this.infoMain?.classList.add('dl-preorder');
      if (this.preorderInfo) {
        this.preorderInfo.innerHTML = dl_product_preorder[variantId];
      }

      // 更新预售属性
      if (this.productForm) {
        const existed = this.productForm.querySelector('input[name="properties[_preorder]"]');
        if (existed) existed.remove();

        const preProInput = document.createElement('input');
        preProInput.type = 'hidden';
        preProInput.name = 'properties[_preorder]';
        preProInput.value = dl_product_preorder[variantId];
        this.productForm.appendChild(preProInput);
      }
    } else {
      this.preTag?.classList.remove('dl-show');
      this.infoMain?.classList.remove('dl-preorder');
      if (this.preorderInfo) {
        this.preorderInfo.innerHTML = '';
      }

      // 移除预售属性
      if (this.productForm) {
        const existed = this.productForm.querySelector('input[name="properties[_preorder]"]');
        if (existed) existed.remove();
      }
    }
  }
}

if (!customElements.get('dl-page-addtocart-x')) {
  customElements.define('dl-page-addtocart-x', DLPageAddToCartX);
}
